<header>
  @if (!environmentIsProduction) {
    <div class="alert-bar">
      <fa-icon [icon]="faExclamationTriangle" class="mx-2 white"></fa-icon>
      <span class="warning-message">This is a preview environment. This is not a live website</span>
      <fa-icon [icon]="faExclamationTriangle" class="mx-2 white"></fa-icon>
    </div>
  }
  <nav class="navbar navbar-expand-sm nex-nav">
    <div class="container-fluid">
      <a [routerLink]="['/manage-orders']" class="navbar-brand">
        <img class="ml-lg-6"
          src="assets/images/clearsignlogo.svg"
          alt="Clear Sign Logo" />
        </a>
        <ul class="nav navbar-nav navbar-right">
        <div [showIfHasCapability]="[
          {
            capabilityString: 'CanAccessSupportWing',
            type: 'system'
          }
        ]">
          <li class="nav-item">
            <button [matMenuTriggerFor]="supportDropdown"
              class="btn btn-secondary clrsgn-nav-item dropdown-toggle">
              Support
            </button>
            <mat-menu #supportDropdown="matMenu">
              <button mat-menu-item [routerLink]="['/support-manage-users']">
                Manage Users
              </button>
              <button mat-menu-item [routerLink]="['/todays-orders-report']">
                Orders Report
              </button>
            </mat-menu>
          </li>
        </div>
    <div [showIfHasCapability]="[
          {
            capabilityString: 'CanAccessAdminWing',
            type: 'client'
          }
        ]">
        <li class="nav-item">
          <button class="btn btn-secondary clrsgn-nav-item"
            [routerLink]="['/manage-users']">
            Admin
          </button>
        </li>
      </div>
      @if (this.isUserLoggedIn()) {
        <li class="nav-item">
          <button class="btn btn-secondary clrsgn-nav-item"
            [routerLink]="['/manage-orders']">
            Manage Orders
          </button>
        </li>
      }
      <li class="nav-item">
        @if (this.isUserLoggedIn()) {
          <button [matMenuTriggerFor]="headerUserDropdown"
            class="btn btn-secondary clrsgn-nav-item dropdown-toggle"
            >
            {{ userName }}
          </button>
        }
        <mat-menu #headerUserDropdown="matMenu">
          <button mat-menu-item (click)="goToMyAccount()">My Account</button>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      </li>
    </ul>
  </div>
</nav>
</header>
